<template>
	<div class="content_container">
		<div class="query">
			<span class="title">小记者站查询</span>
			<van-field required v-model="school" placeholder="请输入学校名查询" />
			<div style="margin: 20px 0;text-align: center;">
				<van-button style="width: 20%;margin: auto;" round block type="primary" size="small" @click="onQuery">
					查询
				</van-button>
			</div>
		</div>
		<div class="container">
			<van-row style="border-bottom: 2px solid #eee;padding: 20px;font-weight: bold;">
				<van-col span="20">小记者站名称</van-col>
			</van-row>
			<van-row v-for="(item, index) in list" :key="index" style="border-bottom: 2px solid #eee;padding: 20px;">
				<van-col span="20">{{ item.school }}</van-col>
				<van-col span="4" style="text-align: right;color: #08f;" @click="toDetail(item)">详情</van-col>
			</van-row>
		</div>
		<van-popup v-model:show="show" style="width: 390px; height: 710px; border-radius: 0 0 20px 20px; "
			position="center">
			<img v-if="vipDataURL" :src="vipDataURL" alt="" style="width: 100%; object-fit: cover;">
			<div v-else ref="vipImg" class="vipImg">
				<img src="../../../../public/static/images/activity/little-reporter/background1.jpg" alt=""
					style="width: 100%; object-fit: cover;">
				<div class="content">
					<van-row class="info">
						<van-col span="8" class="label">类&nbsp;&nbsp;&nbsp;型:</van-col>
						<van-col span="16" class="value">校小记者站</van-col>
					</van-row>
					<van-row class="info">
						<van-col span="8" class="label">学&nbsp;&nbsp;&nbsp;校:</van-col>
						<van-col span="16" class="value">{{ vip.school }}</van-col>
					</van-row>
					<van-row class="info">
						<van-col span="8" class="label">地&nbsp;&nbsp;&nbsp;址:</van-col>
						<van-col span="16" class="value">{{ vip.address }}</van-col>
					</van-row>
					<van-row class="info">
						<van-col span="8" class="label">负责人:</van-col>
						<van-col span="16" class="value">{{ vip.director }}顾问</van-col>
					</van-row>
					<van-row class="info">
						<van-col span="8" class="label">有效期:</van-col>
						<van-col span="16" class="value">{{ vip.lifespan }}</van-col>
					</van-row>
				</div>
			</div>
			<div class="download" @click="htmlDomDownload">下载证件</div>
		</van-popup>
	</div>
</template>

<script>
import { Dialog, Notify } from "vant"
import api_activity from "@/assets/api/api_activity"
import { AuthMixin } from "@/assets/utils/mixin"
import html2canvas from "html2canvas"
import dayjs from "dayjs";

// eslint-disable-next-line no-undef

export default {
	// "最美红色故事发声人"视频、征文报名
	mixins: [AuthMixin],
	name: "wxcarnivalReporterApplyQuery",
	data() {
		return {
			type: 1,
			school: '',
			show: false,
			vip: {},
			list: [],
			vipDataURL: '',
		}
	},
	methods: {
		toDetail(item) {
			this.vip = item;
			this.show = true;
		},
		onQuery() {
			if (!this.school) {
				Notify({ type: "danger", message: "请输入学校名" })
				return;
			}
			let params = {
				school: this.school,
				type: this.type
			}
			api_activity.getReporterNew(params).then((res) => {
				if (res.errcode === 0) {
					this.list = res.data.map(i => {
						return {
							...JSON.parse(i.content),
							lifespan: + dayjs(i.startDate).format("YYYY.MM") + '~' + dayjs(i.endDate).format("YYYY.MM")
						}
					}) || [];
					if (this.list.length === 0) {
						Dialog.alert({
							title: "提示",
							message: "暂无查询结果",
						})
					}
				} else {
					Notify({ type: "danger", message: res.errmsg })
				}
			})
		},
		async htmlDomDownload() {
			const vipImg = this.$refs.vipImg;
			if (!vipImg) return;
			const originalTop = this.$refs.vipImg.querySelector('.content').style.top;
			try {
				this.$refs.vipImg.querySelector('.content').style.top = '180px';
				const canvas = await html2canvas(vipImg, {
					useCORS: true,
					scale: 2, // 放大倍数
				});
				const dataURL = canvas.toDataURL("image/png");
				this.vipDataURL = dataURL;
				const link = document.createElement("a");
				link.href = dataURL;
				link.download = "vip.png";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(dataURL);
				// 微信小程序客户端下载图片处理
				this.$refs.vipImg.querySelector('.content').style.top = originalTop;
				Dialog.alert({
					title: "提示",
					message: "图片已下载，微信手机客户端图片下载失请尝试长按图片保存或截图保存",
				})
			} catch (error) {
				this.$refs.vipImg.querySelector('.content').style.top = originalTop;
				console.error('生成图片失败:', error);
				Notify({ type: "danger", message: "生成图片失败，请重试" });
			}

		},
	},
	watch: {
		show: function (val) {
			if (val) {
				this.vipDataURL = '';
			}
		},
	}
}
</script>
<style lang="less" scoped>
.content_container {
	//   @media (max-width: 800px) {
	//     min-width: 800px;
	//     transform: scale(0.7); /* 缩放为原来的80% */
	//     transform-origin: top left; /* 从左上角开始缩放 */
	//   }
	min-height: 100vh;
	background-color: #fff;
	padding: 25px;

	.query {
		padding: 16px;
		background: #fff;

		.title {
			font-size: 25px;
			font-weight: bold;
			margin-bottom: 8px;
			display: block;
			color: #56b0fe;
		}
	}

	.container {
		margin-top: 50px;
		font-size: 25px;
	}

	.detail {
		margin: 20px;
		border: 1px solid #000;
		border-bottom: none;

		.info {
			font-size: 20px;
			color: #000;
			height: 60px;

			.label {
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
				border-bottom: 1px solid #000;
				border-right: 1px solid #000;
			}

			.value {
				display: flex;
				align-items: center;
				justify-content: center;
				border-bottom: 1px solid #000;
			}

		}
	}

	.vipImg {
		width: 100%;

		.content {
			position: absolute;
			top: 200px;
			width: 350px;
			margin: 20px;
		}

		.title {
			text-align: center;
			font-size: 30px;
			font-weight: bold;
			color: #fff;
			margin: 30px;
		}

		.img {
			width: 150px;
			height: 200px;
			margin: auto;
			display: flex;
			justify-content: center;
			align-items: center;

			img {
				height: 100%;
				width: auto;
			}
		}

		.info {
			font-size: 20px;
			padding: 5px 20px;
			color: #000;
			margin-top: 10px;

			.label {
				text-align: right;
				font-weight: bold;
			}

			.value {
				padding-left: 20px;
				text-align: left;
			}

		}
	}

	.download {
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #000;
		border-radius: 5px;
		font-size: 20px;
	}
}
</style>

<style>
.van-tabs__nav--card {
	margin: 0 !important;
}

.van-dialog__confirm,
.van-dialog__confirm:active {
	color: #56b0fe;
}
</style>
